export default __webpack_public_path__ + "static/media/icons8-setting-100.22eff7f0.svg";